// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FileUploadDragger_wrapper__xNeTM"};